<template>
    <div class="tab-menu__wrap">
        <ul class="tab-menu__list">
            <li v-for="(menu, index) in menuList" :key="index" class="tab-menu__item" :class="{ 'active': activeTab === menu.key }">
                <a href="javascript:;" @click="setActiveTab(menu.key)" class="tab-menu__link">{{ menu.name }}</a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            menuList: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                activeTab: this.menuList[0].key
            };
        },
        methods: {
            setActiveTab(tabKey) {
                this.activeTab = tabKey;
                // 임시 쿼리 제거
                this.$route.query.name = '';
                if(tabKey == 'directions' || tabKey == 'subscription' || tabKey == 'inquiry'){
                    this.$router.push({path: '/CustomerSupport', query: {name: tabKey} })
                }
                if(tabKey == 'osangTechnology' || tabKey == 'capabilities' || tabKey == 'strategy'){
                    this.$router.push({path: '/Introduction', query: {name: tabKey} })
                }
                if(tabKey == 'introduction' || tabKey == 'differentiation' || tabKey == 'technology' || tabKey == 'security'){
                    this.$router.push({path: '/Service', query: {name: tabKey} })
                }
                this.$emit('changeTitle', tabKey);
            },
        },

        watch: {
            '$route.query': {
                handler(newQuery) {
                    this.activeTab = newQuery.name || this.menuList[0].key;
                },
                immediate: true
            }
        }
    };
</script>